import { EnrollmentPeriods } from './../model/enrollment-periods.model';
import { ServiceDeliveryService } from './../../../children/service-delivery/service/service-delivery.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

@Component({
    selector: 'service-period-dropdown',
    templateUrl: './service-period-dropdown.component.html',
    styleUrls: ['./service-period-dropdown.component.scss']
})
export class ServicePeriodDropdownComponent implements OnInit {
    @Input() label: string = '';
    @Input() isMultiple: boolean = false;
    @Input() required: boolean = false;
    @Input() disabled: boolean = false;

    @Input('reset') reset: boolean;
    @Output() servicePeriodEvent = new EventEmitter<EnrollmentPeriods[]>();

    servicePeriods: EnrollmentPeriods[] = [];
    filteredServicePeriods: EnrollmentPeriods[] = [];

    form: UntypedFormGroup;
    @ViewChild(MatSelect) matSelect: MatSelect;

    subs: Subscription[] = [];

    isLoading: boolean = false;

    constructor(private serviceDeliveryService: ServiceDeliveryService, private fb: UntypedFormBuilder) {
        this.form = this.fb.group({
            servicePeriodSelect: [[]]
        });

        this.getServicePeriods();
        this.subscribers();
    }

    ngOnInit(): void {}

    subscribers() {
        let serviceSelectSub = this.servicePeriodSelect.valueChanges.subscribe((servicePeriods: EnrollmentPeriods[]) => {
            this.servicePeriodEvent.emit(servicePeriods);
        });
        this.subs.push(serviceSelectSub);
    }

    ngOnChanges(): void {
        if (this.reset) {
            this.resetFunction();
        }

        if (this.disabled) {
            this.servicePeriodSelect.disable();
        } else {
            this.servicePeriodSelect.enable();
        }
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    getServicePeriods() {
        this.isLoading = true;
        this.serviceDeliveryService.getEnrollmentPeriods().subscribe((res) => {
            if (res.result) {
                this.servicePeriods = res.result.sort((a: any, b: any) => a.ID.toString()!.localeCompare(b.ID.toString()!));

                this.filteredServicePeriods = this.servicePeriods.filter(
                    (servicePeriod) =>
                        servicePeriod.PERIOD!.toString().includes('Regular Year') ||
                        servicePeriod.PERIOD!.toString().includes('Summer') ||
                        servicePeriod.PERIOD!.toString().includes('Intersession') ||
                        servicePeriod.PERIOD!.toString().includes('N (Pre 2017-18)')
                );
            } else {
            }

            this.isLoading = false;
        });
    }

    get servicePeriodSelect(): AbstractControl {
        return this.form.get('servicePeriodSelect')!;
    }

    selectAll(type?: string) {
        if (this.isMultiple) {
            this.servicePeriodSelect.patchValue(this.filteredServicePeriods);
        }
    }

    deSelectAll() {
        this.reset = false;
        this.servicePeriodSelect.patchValue([]);

        if (!this.isMultiple) {
            this.close();
        }
    }

    close() {
        this.matSelect.close();
    }

    resetFunction() {
        this.servicePeriodSelect.setValue([]);
        this.servicePeriodEvent.emit([]);
        this.reset = false;
    }

    get schoolSelect(): any {
        return this.form.get('servicePeriodSelect');
    }

    onOpen(opened: boolean) {}
}
